// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  LeaseGraderChatMessage,
  LeaseGraderDocumentInput,
  LeaseGraderReplyRow,
} from "./types";

export const params = {
  sessionId: __t.string(),
  get messages() {
    return __t.array(LeaseGraderChatMessage);
  },
  get documents() {
    return __t.array(LeaseGraderDocumentInput);
  },
};
export const returnType = LeaseGraderReplyRow